import React from 'react';

interface ClockIconProps {
  hour?: any;
  minutes?: any;
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const getRotations = (hour, minutes) => {
  let hourDegrees = Math.floor((hour / 12) * 360 - 90);
  const minutesDegrees = Math.floor((minutes / 60) * 360);
  if (hourDegrees === 270 || (hourDegrees === 90 && minutesDegrees === 180)) {
    hourDegrees += 4;
  }
  const hourRotation = hourDegrees + 'deg';
  const minutesRotation = minutesDegrees + 'deg';
  return { hourRotation, minutesRotation };
};

function ClockIcon({
  width = 19,
  height = 19,
  hour,
  minutes,
  fill = '#525252',
  ...rest
}: ClockIconProps) {
  const { hourRotation, minutesRotation } = getRotations(hour, minutes);

  // tslint:disable max-line-length
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill={fill}
    >
      <g>
        <path d="M9.5,0 C4.26073888,0 0,4.26073888 0,9.5 C0,14.7396594 4.26042199,19 9.5,19 C14.739578,19 19,14.7396594 19,9.5 C19,4.26073886 14.7392612,0 9.5,0 Z M9.5,1 C14.1869764,1 18,4.81302361 18,9.5 C18,14.1873704 14.1872975,18 9.5,18 C4.81270246,18 1,14.1873704 1,9.5 C1,4.81302362 4.81302362,1 9.5,1 Z" />
        <line
          style={{
            transformOrigin: 'center',
            transform: `rotate(${minutesRotation})`,
          }}
          x1="9.5"
          y1="9.5"
          x2="9.5"
          y2="2"
          stroke={fill}
        />
        <line
          style={{
            transformOrigin: 'center',
            transform: `rotate(${hourRotation})`,
          }}
          x1="9.5"
          y1="9.5"
          x2="15"
          y2="9.5"
          stroke={fill}
        />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default ClockIcon;
